import PropTypes from "prop-types";
import { Nav } from "react-bootstrap";
import "./navOptions.css";
import { Row, Col } from "react-bootstrap";

const NavOptions = ({ activeRoute, setActiveRoute }) => {
  const navsNames = ["Downloads", "Basemaps", "Services", "Viewer", "MRLC"];
  const navItems = navsNames.map((navName, i) => {
    return (
      <Nav.Item key={i} className="route-btn nav nav-pills">
        <Nav.Link eventKey={i + 1}> {navName} </Nav.Link>
      </Nav.Item>
    );
  });

  return (
    <Row>
      <Col sm="10">
        <Nav
          variant="pills"
          activeKey={activeRoute || 1}
          className="route-btn nav nav-pills"
          onSelect={(selectedKey) => setActiveRoute(parseInt(selectedKey, 10))}
        >
          {navItems}
        </Nav>
      </Col>
      <Col sm="2"></Col>
    </Row>
  );
};

NavOptions.propTypes = {
  activeRoute: PropTypes.number.isRequired,
  setActiveRoute: PropTypes.func.isRequired,
};

export default NavOptions;
